/* eslint-disable react/prop-types */

import { motion } from "framer-motion"
import styled from "styled-components"

const ColorContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin: 1rem 0;
`

const ColorButton = styled(motion.button)`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background: ${(props) => props.$bgColor};
  cursor: pointer;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    border-radius: 50%;
    border: 2px solid white;
    opacity: 0;
    transition: opacity 0.2s;
  }

  &.active::after {
    opacity: 1;
  }

  @media (max-width: 480px) {
    width: 32px;
    height: 32px;
  }
`


export function ColorSelector({ colors, activeColor, onColorSelect }) {
  console.log(colors)
  return (
    <ColorContainer>
      {colors?.map((color, index) => {
        if (color == "") return 
        return (
        <ColorButton
          key={index}
          $bgColor={color}
          className={activeColor === color ? "active" : ""}
          onClick={() => onColorSelect(color)}
          whileHover={{ scale: 1.2 }}
          whileTap={{ scale: 0.9 }}
        /> )
    })}
    </ColorContainer>
  )
}

